import React, { useEffect, useRef, useState } from "react";
import Images from "../../assets/Image";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import emailjs from "@emailjs/browser";
const ByIndustryComp = () => {
  const {
    formState: { errors },
    register,
  } = useForm();
  const navigate = useNavigate();
  const form = useRef();
  const industrialsectors = [
    {
      image: Images?.industry1,
      sectorName: "Automobile",
      path: "/byindustry/automobile",
      title: "click to navigate automobile",
    },
    {
      image: Images?.industry2,
      sectorName: "Breweries & Distilleries",
      path: "/byindustry/breweries",
      title: "click to navigate breweries & distilleries",
    },
    {
      image: Images?.industry3,
      sectorName: "Chemical",
      path: "/byindustry/chemical",
      title: "click to navigate chemical",
    },
    {
      image: Images?.industry4,
      sectorName: "Electrical",
      path: "/byindustry/electrical",
      title: "click to navigate electrical",
    },
    {
      image: Images?.industry5,
      sectorName: "Food & Beverage",
      path: "/byindustry/foodandbeverage",
      title: "click to navigate food & beverage",
    },
    {
      image: Images?.industry6,
      sectorName: "Personal care",
      path: "/byindustry/personalCare",
      title: "click to navigate personal care",
    },
    {
      image: Images?.industry7,
      sectorName: "Pharma",
      path: "/byindustry/pharma",
      title: "click to navigate pharma",
    },
    {
      image: Images?.industry8,
      sectorName: "Telecom & Infrastructure",
      path: "/byindustry/telecom",
      title: "click to navigate telecom & infrastructure",
    },
    {
      image: "",
      sectorName: "",
      path: "",
    },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const [showIcons, setShowIcons] = useState(false);

  // Custom hook for Intersection Observer
  useEffect(() => {
    // For the address block
    const addressElements = document.querySelectorAll(
      ".contactEnquiryAddressBlock",
    );
    const addressObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible-address");
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    addressElements.forEach((el) => addressObserver.observe(el));

    // For the form fields
    const inputFields = document.querySelectorAll(".enquiryFormInputField");
    const formObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              entry.target.classList.add("visible-form");
            }, index * 300); // stagger the animation for each field
          }
        });
      },
      {
        threshold: 0.1,
      },
    );
    inputFields.forEach((input) => formObserver.observe(input));

    return () => {
      addressObserver.disconnect();
      formObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      setShowIcons(true);
    } else {
      setShowIcons(false);
    }
  }, [isOpen]);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_520oyz9", "template_xr5ts3y", form.current, {
        publicKey: "YI1Dlv7k1QHWv_o9e",
      })
      .then(
        () => {
          console.log("SUCCESS!");
          alert("form submitted successfully..");
        },
        (error) => {
          console.log("FAILED...", error.text);
        },
      );
  };
  return (
    <>
      <div className="industry_heading_block">
        <div className="industry_left_block">
          <div className="contactus_heading_container">
            <h6 className="industry_heading my-3">BY INDUSTRY</h6>
          </div>
        </div>
        <div className="industry_right_block">
          <div className="industry_image_block">
            <img
              src={Images?.byIndustryIcon}
              alt="no-image"
              className="image_icon"
            />
          </div>
        </div>
      </div>
      <div className="contact_us_sub_heading_block">
        <h5 className="contact_us_sub_title">
          ONE‐STOP SHOP ‐ FROM AN ‘INDUSTRY’ PERSPECTIVE
        </h5>
        <p className="event_content_para">
          USP looks at the broad requirement of packaging solutions for the
          industry by customising every one of its specific requirements ‐
          however varied they may be ‐ with <br /> performance efficiency and
          cost‐effectiveness as foremost priorities. As solutions offered by us
          are need‐based, customisation is key to success, since one’s need{" "}
          <br /> will be vastly different from that of the other like, for
          instance, some companies stress the need for quality print; some
          others target a printer that will work on a <br /> specific substrate.
          There is, then, a load of in‐situ challenges ‐ unceasing production,
          adaptability to varied working conditions and, differences in
          packaging <br /> requirements
        </p>
      </div>
      <div className="industrial_sectors_main_block ">
        <h6 className="industial_sectors_heading">Our industrial sectors</h6>
      </div>

      <div className="industrial_sectors_section">
        <div className="industrial_sectors_card_block">
          {industrialsectors?.map((val, index) => {
            if (index == 8) {
              return (
                <>
                  <div
                    className="byapplication_card"
                    key={index}
                    onClick={() => {
                      navigate(val?.path);
                    }}
                    title={val?.title}
                  ></div>
                </>
              );
            } else {
              return (
                <>
                  <div
                    className="byapplication_card"
                    key={index}
                    onClick={() => {
                      navigate(val?.path);
                    }}
                    title={val?.title}
                  >
                    <div className="byapplication_image-container">
                      <img
                        src={val?.image}
                        alt="no-image"
                        className="image_icon"
                      />
                    </div>
                    <h6 className="industrial_sectors_card_title">
                      {val?.sectorName}
                    </h6>
                  </div>
                </>
              );
            }
          })}
        </div>
      </div>

      <div className="contactUs_Main_Section">
        <div className="contactusEnquirySection">
          <div className="contactUsEnquiryAddressBlock">
            <h6 className="enquiry_address_heading">Contact us</h6>
            <p className="--contact-address my-3">
              Have a question or interested in learning more about us and our
              products? Please contact us using the "Get in Touch" form below or
              by emailing <u style={{ color: "#3185D2" }}>enquiries@usppkg.com</u>
              / by calling  <u style={{ color: "#3185D2" }}>+91 9790934910</u>.
            </p>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.locationIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>

              <p className="--contact-address">
                Old No. 15/1, New No. 37, Dr.Muthulakshmi Salai,
                <br /> Lattice Bridge Road, Adyar, Chennai 600020, India.
              </p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.phoneCall}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">+91 9790934910</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.meaageIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">enquiries@usppkg.com</p>
            </div>
            <div className="contactEnquiryAddressBlock">
              <div className="enquiry_card_img_block">
                <div className="enquiry_card-image">
                  <img
                    src={Images?.clockIcon}
                    alt="no-image"
                    className="image_icon"
                  />
                </div>
              </div>
              <p className="--contact-address">
                Mon-Fri 9.30 am to 6.00 pm
                <br />
                Sat 9.30 am to 1.00 pm
              </p>
            </div>
          </div>
          <div className="contactUsEnquiryFormBlock">
            <h5 className="contactUsEnquiryFormHeading">Get In Touch</h5>
            <form ref={form} onSubmit={sendEmail}>
              <div>
                <input
                  type="text"
                  name="from_name"
                  className="enquiryFormInputField"
                  placeholder="Name"
                  required
                />
              </div>
              <div>
                <input
                  type="email"
                  name="from_email"
                  className="enquiryFormInputField"
                  placeholder="Email Id"
                  required
                />
              </div>
              <div>
                <input
                  type="tel"
                  name="mobileNumber"
                  className="enquiryFormInputField"
                  placeholder="Mobile Number"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="need"
                  className="enquiryFormInputField"
                  placeholder="Need"
                  required
                />
              </div>
              <div>
                <input
                  type="text"
                  name="message"
                  className="enquiryFormInputField"
                  placeholder="What is your need"
                  required
                />
              </div>
              <div className="contactus_btn_block">
                <button className="contactUsSubmitBtn">Submit Now</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div>
        {!isOpen && (
          <>
            <button className="blog_content_bottom_btn">
              tap to connect here
            </button>
            <div
              className="blog_bottom_share"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              +
            </div>
          </>
        )}

        {isOpen && (
          <>
            <div
              className={`blog_share_icons_block ${showIcons ? "show" : ""}`}
            >
              <img
                src={Images?.whatsappIcon}
                alt="whatsapp"
                className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                  }`}
              />
              <img
                src={Images?.instagramIcon}
                alt="instagram"
                className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                  }`}
              />
              <img
                src={Images?.facebookIcon}
                alt="facebook"
                className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                  }`}
              />
              <img
                src={Images?.youtueIcon}
                alt="youtube"
                className={`blog_share_icones_sizes ${showIcons ? "showIcon" : ""
                  }`}
              />
            </div>
            <div
              className="blog_bottom_share"
              onClick={() => {
                setIsOpen(!isOpen);
                setShowIcons(false);
              }}
            >
              x
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ByIndustryComp;
